import { render } from "./SecondariesTokenAmountForm.vue?vue&type=template&id=53643776&scoped=true"
import script from "./SecondariesTokenAmountForm.vue?vue&type=script&lang=js"
export * from "./SecondariesTokenAmountForm.vue?vue&type=script&lang=js"

import "./SecondariesTokenAmountForm.vue?vue&type=style&index=0&id=53643776&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53643776"]])

export default __exports__